module.exports = __webpack_public_path__ + "resources/img/img_equipment4.971347e581139e599809cc5219ad3829.png";